module.exports = __webpack_public_path__ + "img/统计分析备份@2x.f9089501.png";